import {DEFAULT_TIME_ZONE} from 'src/internal/constants';

const browserTimeZone: string = DEFAULT_TIME_ZONE;

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-intl/api/browserTimeZone
 */
export default browserTimeZone;
